<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModel()"></button>
</div>

<div class="modal-body">
  <p>{{ baseMessage }}</p>
  @if (sessionExpired) {
    Sign in to continue using the cyber compliance portal.
  } @else {
    You will be logged out in {{ countdown ? countdown : 'few' }} seconds.
  }
</div>

<div class="modal-footer">
  <button size="sm" cButton color="primary" (click)="closeModel()">
    {{ cancelButtonLabel }}
  </button>
</div>
